import { useEffect, useState } from "react";
import { FiSettings } from "react-icons/fi";
import Sidebar from "./SideBar";
import { FaSun, FaMoon, FaDesktop, FaSync } from "react-icons/fa";
import { useSelector } from "react-redux";
import { motion } from "framer-motion";
const CenteredSettings = () => {
  const url = window.location.href;
  if (url.includes("add-associate-by-ref")) {
    return null;
  }
  const appType = useSelector((state) => state?.uiReducers?.appType);
  const [showSideBar, setSideBar] = useState(false);
  const handleSetting = () => setSideBar((prev) => !prev);
  const [primaryColor, setPrimaryColor] = useState("");
  const [mode, setMode] = useState("");
  const [colors, setColor] = useState([
    { name: "purple", hex: "#6f42c1" },
    { name: "teal", hex: "#20c997" },
    { name: "red", hex: "#dc3545" },
    { name: "yellow", hex: "#ffc107" },
    { name: "blue", hex: "#0d6efd" },
    { name: "custom", hex: primaryColor },
  ]);
  // Change Theme Color
  const changeTheme = (themeColor) => {
    setColor((pre) => [
      { name: "purple", hex: "#6f42c1" },
      { name: "teal", hex: "#20c997" },
      { name: "red", hex: "#dc3545" },
      { name: "yellow", hex: "#ffc107" },
      { name: "blue", hex: "#0d6efd" },
      { ...pre[pre.length - 1], hex: themeColor },
    ]);
    document.documentElement.style.setProperty(
      "--themeColor",
      appType === "Business" ? themeColor : "#7B3A00"
    );
    document.documentElement.style.setProperty("--walletIconBg", themeColor);

    document.documentElement.style.setProperty(
      "--nav-color",
      appType === "Business" ? themeColor : "#7B3A00"
    );
  };
  // Reset / Refresh functionality
  const handleRefresh = () => {
    // changeTheme()
    setPrimaryColor("");
    setMode("");
    // reset variables
    document.documentElement.style.setProperty(
      "--themeColor",
      appType === "Business" ? "#222843" : "#7B3A00"
    );
    document.documentElement.style.setProperty("--cardColor", "");
    document.documentElement.style.setProperty("--bg-white", "");
    document.documentElement.style.setProperty("--text-color", "");
    document.documentElement.style.setProperty("--heading-color", "");
    document.documentElement.style.setProperty("--walletIconBg", "");
    document.documentElement.style.setProperty("--label-color", "");

    document.body.style.backgroundColor = "#fff";
    document.body.style.color = "#000";
    document.documentElement.style.setProperty(
      "--nav-color",
      appType === "Business" ? "#f7f9ff" : "#7B3A00"
    );
  };
  useEffect(() => {
    // Update theme when color changes
    const selectedColor = colors.find((c) => c.name === primaryColor)?.hex;
    if (selectedColor) {
      changeTheme(selectedColor);
    }
  }, [primaryColor]);

  useEffect(() => {
    const applyDarkMode = () => {
      changeTheme("#ffc107");

      document.body.style.backgroundColor = "#121212";
      document.body.style.color = "#ffc107";
      document.documentElement.style.setProperty(
        "--bg-nav",
        appType === "Business" ? "#302b49" : "#7B3A00"
      );
      document.documentElement.style.setProperty("--subtable-bg", "#333");
      document.documentElement.style.setProperty(
        "--nav-color",
        appType === "Business" ? "#f7F9FF" : "#7B3A00"
      );
      document.documentElement.style.setProperty("--cardColor", "#302b49");
      document.documentElement.style.setProperty(
        "--ttpl-body-color",
        "#fafafaff"
      );
      document.documentElement.style.setProperty("--bg-white", "#302b49");
      document.documentElement.style.setProperty("--text-color", "#fff");
      document.documentElement.style.setProperty("--heading-color", "#ffc107");
      document.documentElement.style.setProperty("--label-color", "#fff");
    };

    const applyLightMode = () => {
      changeTheme("#121212");
      document.documentElement.style.setProperty(
        "--bg-nav",
        appType === "Business" ? "#3a3f4a" : "#7B3A00"
      );
      document.documentElement.style.setProperty(
        "--nav-color",
        appType === "Business" ? "#f7f9ff" : "#7B3A00"
      );
      document.documentElement.style.setProperty("--walletIconBg", "");
      document.body.style.backgroundColor = "#fff";
      document.body.style.color = "#000";
      document.documentElement.style.setProperty(
        "--ttpl-body-color",
        "#31374a"
      );
      document.documentElement.style.setProperty("--subtable-bg", "");
      document.documentElement.style.setProperty("--cardColor", "#ffffff");
      document.documentElement.style.setProperty("--bg-white", "#ffffff");
      document.documentElement.style.setProperty("--text-color", "");
      document.documentElement.style.setProperty("--heading-color", "");
      document.documentElement.style.setProperty("--label-color", "");
    };
    if (mode === "dark") {
      applyDarkMode();
    } else if (mode === "light") {
      applyLightMode();
    } else {
      const mql = window.matchMedia("(prefers-color-scheme: dark)");
      const systemThemeChange = (e) => {
        if (e.matches) {
          applyDarkMode();
        } else {
          applyLightMode();
        }
      };

      if (mql.matches) {
        applyDarkMode();
      } else {
        applyLightMode();
      }

      mql.addEventListener("change", systemThemeChange);

      return () => {
        mql.removeEventListener("change", systemThemeChange);
      };
    }
  }, [mode, appType]);

  return (
    <>
      <div
        className="position-fixed d-flex  justify-content-end top-50 end-0 translate-middle-y"
        style={{ zIndex: 9990, width: "fit-content" }}
      >
        <button
          className="btn   d-flex   align-items-center justify-content-center shadow top-50 end-0 translate-middle-y"
          onClick={handleSetting}
          style={{
            backgroundColor: "var(--themeColor, #6f42c1)",
            color: "#fff",
            borderRadius: "30px 0 0 30px",
            padding: "12px 16px",
          }}
        >
          <motion.div
            animate={{ rotate: showSideBar ? 180 : 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
          >
            <FiSettings size={22} />
          </motion.div>
        </button>
      </div>
      {/* Sidebar */}
      {showSideBar && (
        <Sidebar
          setIsFilter={handleSetting}
          heading="Theme Customizer"
          subHeading="Customize & Preview in Real Time"
          IsNotOverLay={true}
        >
          <div className="p-3">
            <h6 className="fw-bold mb-2 fs-8">Primary Color</h6>
            <div className="d-flex gap-2 mb-3 flex-wrap">
              {colors.map((c) =>
                c.name === "custom" ? (
                  <div
                    key={c.name}
                    className="bg-white p-1 rounded"
                    style={{
                      border:
                        primaryColor === c.name
                          ? `2px solid ${c.hex}`
                          : `1px solid gray`,
                      position: "relative",
                    }}
                  >
                    <label
                      onClick={() => setPrimaryColor(c.name)}
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: c.hex,
                        border: "none",
                      }}
                      htmlFor="color"
                      className="rounded d-flex align-items-center justify-content-center"
                    >
                      <input
                        id="color"
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          opacity: 0,
                          cursor: "pointer",
                        }}
                        type="color"
                        onChange={(e) => changeTheme(e.target.value)}
                      />
                      <i class="bi bi-palette fs-6  text-white"></i>
                    </label>
                  </div>
                ) : (
                  <div
                    key={c.name}
                    className="bg-white p-1 rounded"
                    style={{
                      border:
                        primaryColor === c.name
                          ? `2px solid ${c.hex}`
                          : `1px solid gray`,
                    }}
                  >
                    <button
                      className="rounded d-flex align-items-center justify-content-center"
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: c.hex,
                        border: "none",
                      }}
                      onClick={() => setPrimaryColor(c.name)}
                    />
                  </div>
                )
              )}
            </div>
            <h6 className="fw-bold mb-2 fs-8">Mode</h6>
            <div className="d-flex gap-2 mb-3">
              <button
                className={`btn w-100 ${
                  mode === "light"
                    ? "border border-2 text-color border-primary"
                    : "border text-color"
                }`}
                onClick={() => setMode("light")}
              >
                <FaSun className="me-2" /> Light
              </button>
              <button
                className={`btn w-100 ${
                  mode === "dark"
                    ? "border border-2 text-color border-primary"
                    : "border text-color"
                }`}
                onClick={() => setMode("dark")}
              >
                <FaMoon className="me-2" /> Dark
              </button>
              <button
                className={`btn w-100 ${
                  mode === "system"
                    ? "border border-2 text-color border-primary"
                    : "border text-color"
                }`}
                onClick={() => setMode("system")}
              >
                <FaDesktop className="me-2" /> System
              </button>
            </div>
            <button
              style={{ border: "1px solid var(--text-color)" }}
              className="btn btn-outline-secondary w-100 d-flex text-color align-items-center justify-content-center"
              onClick={handleRefresh}
            >
              <FaSync className="me-2" /> Refresh / Reset
            </button>
          </div>
        </Sidebar>
      )}
    </>
  );
};

export default CenteredSettings;
